"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'60vh',flexDirection:'column',gap:'8px'}}>
      <h1 style={{fontSize:'28px',fontWeight:700}}>Une erreur s&apos;est produite</h1>
      <p>Une erreur inattendue s&apos;est produite. Veuillez réessayer plus tard.</p>
      <button 
        onClick={() => window.location.reload()} 
        style={{
          padding: '8px 16px',
          backgroundColor: '#2563eb',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Recharger la page
      </button>
    </div>
  );
}